import { createAction, handleActions } from 'redux-actions';
import { pender } from 'redux-pender';
import * as api from 'app/api';
import produce from 'immer';
import HttpClient from 'app/api/HttpClient';
import { marketingTermsManager } from '@encarpkg/shared';

const INIT = 'auth/INIT';
export const init = createAction(INIT);

const LOGGEDIN_FALSE = 'auth/LOGGEDIN_FALSE';
export const loggedInFalse = createAction(LOGGEDIN_FALSE);

const SESSION_CHECK = 'auth/SESSION_CHECK';
export const sessionCheck = createAction(SESSION_CHECK, HttpClient.authentication);

const GET_USER_INFO = 'auth/GET_USER_INFO';
export const getUserInfo = createAction(GET_USER_INFO, api.getUserDetailInfoByToken);

const initialState = {
	isLoggedIn: null,
	user: null,
	userInfo: null,
};

export default handleActions(
	{
		[LOGGEDIN_FALSE]: (state) =>
			produce(state, (draft) => {
				draft.isLoggedIn = false;
				draft.user = null;
				draft.userInfo = null;
			}),

		...pender({
			type: SESSION_CHECK,
			onSuccess: (state, { payload }) =>
				produce(state, (draft) => {
					draft.isLoggedIn = true;
					draft.user = payload?.data?.siteUser || {};

					marketingTermsManager().setViewCookie();
				}),
			onFailure: (state) =>
				produce(state, (draft) => {
					draft.isLoggedIn = false;
					draft.user = null;

					marketingTermsManager().removeViewCookie();
				}),
		}),

		...pender({
			type: GET_USER_INFO,
			onSuccess: (state, { payload }) =>
				produce(state, (draft) => {
					draft.userInfo = payload?.data || {};
				}),
		}),
	},
	initialState,
);
